/**
 * Created by coolguy on 2017/8/10.
 */

import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('qrcode');
const QRCODE_ADD = "QRCODE_ADD";
const QRCODE_EDIT = "QRCODE_EDIT";
const QRCODE_DETAIL = "QRCODE_DETAIL";
const QRCODE_FOLLOW = "QRCODE_FOLLOW";
const QRCODE_LIST = "QRCODE_LIST";

export default {
    QRCODE_ADD,
    qrcodeAdd : (params)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:QRCODE_ADD,
                data
            })
        })
    },
    QRCODE_EDIT,
    qrcodeEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:QRCODE_EDIT,
                data,
            })
        })
    },
    QRCODE_DETAIL,
    qrcodeDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')(id),
            success:(data)=>({
                type:QRCODE_DETAIL,
                data,
            })
        })
    },
    QRCODE_FOLLOW,
    qrcodeFollow:()=>{
        return ajaxCommon({
            api:{
                url:'/api/qrcode/follow',
                method:'get'
            },
            success:(data)=>({
                type:QRCODE_FOLLOW,
                data,
            })
        })
    },
    QRCODE_LIST,
    qrcodes: (search)=>{
        search.page = search.current || 1;//保持antd的风格
        return ajaxCommon({
            //testData:mock.list,
            api:TheApi('get')(),
            data:search,
            success: (data)=>({
                type:QRCODE_LIST,
                data
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/actions/QrcodeAction.js